import SelectReact from "react-select";
import {colorStyles} from "../../../components/elements/Inputs/SelectComponent";
import {useEffect, useState} from "react";
import api from "../../../js/api";
import {toastError} from "../../../js/toast";
import {
    BuildingStorefrontIcon
} from "@heroicons/react/24/solid";

const SelectWarehouse = (props) => {
    const [didMount, setMount] = useState(false);
    const [loaderWarehouse, setLoaderWarehouse] = useState(false);

    useEffect(() => {
        setMount(true)
    }, [])

    useEffect(() => {
        if (didMount) {
            setLoaderWarehouse(true)
            api.get('warehouse/options')
                .then((response) => {
                    if (response.data?.length) {
                        props.setOptionWarehouseSelected(response.data[0])
                        props.setOptionWarehouse(response.data);
                    } else {
                        toastError('No se puede ralizar una venta si no existe una bodega')
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                    setLoaderWarehouse(false)
                });
        }
    }, [didMount])

    return (
        <div className="w-full flex mb-2 justify-end">
            <div className="w-fit flex flex-row">
                <div className="flex align-middle mt-2 content-center border items-center px-1">
                    <BuildingStorefrontIcon className="w-6 h-6"/>
                </div>
                <SelectReact
                    isDisabled={props.disabled}
                    isLoading={loaderWarehouse}
                    value={props.warehouseSelected}
                    loadingMessage={() => <div>Sin datos</div>}
                    onChange={props.setOptionWarehouseSelected}
                    placeholder="Bodega"
                    styles={colorStyles(false)}
                    className="mt-2 mb-0 cursor-pointer !text-black"
                    options={props.optionWarehouse}
                />
            </div>
        </div>
    )

}

export default SelectWarehouse;